function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 0a.5.5 0 01.5.5V6h5.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H7.999L8 13.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5L5.999 8H.5a.5.5 0 01-.5-.5v-1A.5.5 0 01.5 6H6V.5a.5.5 0 01.5-.5h1z"
})));